<div data-testid="error-dialog-content" class="error-dialog-content">
  <p data-testid="error-dialog-message" class="error-message">
    {{ message | translate }}
  </p>
  <div data-testid="error-dialog-actions" class="error-actions">
    <p-button
      data-testid="error-dialog-close-btn"
      [label]="'common.actions.close' | translate"
      severity="danger"
      (onClick)="onClose()"
    />
  </div>
</div>
